import _slicedToArray from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/regenerator/index.js";
import { asyncRunOnReadyState, monitorError } from '@datadog/browser-core';
import { getSessionReplayLink as _getSessionReplayLink } from '../domain/getSessionReplayLink';
export function createPostStartStrategy(configuration, lifeCycle, sessionManager, viewHistory, loadRecorder, getOrCreateDeflateEncoder) {
  var status = 0 /* RecorderStatus.Stopped */;
  var stopRecording;
  lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
    if (status === 2 /* RecorderStatus.Starting */ || status === 3 /* RecorderStatus.Started */) {
      stop();
      status = 1 /* RecorderStatus.IntentToStart */;
    }
  });
  lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
    if (status === 1 /* RecorderStatus.IntentToStart */) {
      start();
    }
  });
  var doStart = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$Promise$all, _yield$Promise$all2, startRecordingImpl, deflateEncoder, _startRecordingImpl;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([loadRecorder(), asyncRunOnReadyState(configuration, 'interactive')]);
          case 2:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            startRecordingImpl = _yield$Promise$all2[0];
            if (!(status !== 2 /* RecorderStatus.Starting */)) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return");
          case 7:
            deflateEncoder = getOrCreateDeflateEncoder();
            if (!(!deflateEncoder || !startRecordingImpl)) {
              _context.next = 11;
              break;
            }
            status = 0 /* RecorderStatus.Stopped */;
            return _context.abrupt("return");
          case 11:
            ;
            _startRecordingImpl = startRecordingImpl(lifeCycle, configuration, sessionManager, viewHistory, deflateEncoder);
            stopRecording = _startRecordingImpl.stop;
            status = 3 /* RecorderStatus.Started */;
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function doStart() {
      return _ref.apply(this, arguments);
    };
  }();
  function start(options) {
    var session = sessionManager.findTrackedSession();
    if (canStartRecording(session, options)) {
      status = 1 /* RecorderStatus.IntentToStart */;
      return;
    }
    if (isRecordingInProgress(status)) {
      return;
    }
    status = 2 /* RecorderStatus.Starting */;
    // Intentionally not awaiting doStart() to keep it asynchronous
    doStart()["catch"](monitorError);
    if (shouldForceReplay(session, options)) {
      sessionManager.setForcedReplay();
    }
  }
  function stop() {
    if (status === 3 /* RecorderStatus.Started */) {
      stopRecording === null || stopRecording === void 0 ? void 0 : stopRecording();
    }
    status = 0 /* RecorderStatus.Stopped */;
  }
  return {
    start: start,
    stop: stop,
    getSessionReplayLink: function getSessionReplayLink() {
      return _getSessionReplayLink(configuration, sessionManager, viewHistory, status !== 0 /* RecorderStatus.Stopped */);
    },
    isRecording: function isRecording() {
      return status === 3;
    } /* RecorderStatus.Started */
  };
}
function canStartRecording(session, options) {
  return !session || session.sessionReplay === 0 /* SessionReplayState.OFF */ && (!options || !options.force);
}
function isRecordingInProgress(status) {
  return status === 2 /* RecorderStatus.Starting */ || status === 3 /* RecorderStatus.Started */;
}
function shouldForceReplay(session, options) {
  return options && options.force && session.sessionReplay === 0 /* SessionReplayState.OFF */;
}